const cookie = require('js-cookie');

/**
 * External dependencies
 */
const { merge } = require('lodash');
const qs = require('qs');
const { fetch, fetchWithoutToken } = require('./Fetch');
const {
  removeToken,
  isAllowSwitchSupplier,
} = require('../components/authentication/Authentication');
/**
 * Internal dependencies
 */

const options = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

const url = process.env[`REACT_APP_ORDERS_API_${process.env.REACT_APP_ENV}`];

const subUrls = {
  ORDERS_LIST: 'orders/orders',
  ORDERS_UPDATE: 'orders/tracking/',
  ORDERS_SHIPMENT_SPLIT: 'orders/shipments/',
  ORDERS_SHIPMENT_STATS: 'orders/stats/shipments',
  ORDERS_REVENUE: 'orders/stats/by-revenue',
  ORDERS_BY_STATUS: 'orders/stats/by-status',
  JWT_CHECK: '/token/me',
  PRODUCTS: 'products',
  PRODUCTS_VARIANCES: 'products/variances',
  PRODUCTS_UPDATE: 'products/variants',
  SUPPLIER_STATEMENT: 'suppliers/statements',
  MARKETPLACE_SUPPLIERS: 'suppliers',
  CARRIERS: 'carriers',
};

const DEFAULT_FILTERS = {
  type: 'brand-direct',
};

const getCognitoTokens = code => {
  const fetchTokenUrl = `${
    process.env[`REACT_APP_COGNITO_URL_${process.env.REACT_APP_ENV}`]
  }/oauth2/token`;
  const data = `client_id=${
    process.env[`REACT_APP_COGNITO_CLIENT_ID_${process.env.REACT_APP_ENV}`]
  }&redirect_uri=${
    process.env[`REACT_APP_COGNITO_REDIRECT_URI_${process.env.REACT_APP_ENV}`]
  }&grant_type=authorization_code&code=${code}`;

  return fetchWithoutToken(fetchTokenUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: data,
  });
};

/**
 * Get is the user allow to switch supplier
 * @return {boolean}
 */
const getIsAllowSwitchSupplier = () => isAllowSwitchSupplier();
/**
 * Get current supplierId from cookie
 * @return {String}
 */
const getCurrentSupplierId = () => cookie.get('currentSupplierId');

const cognitoLogOut = () => {
  const fetchTokenUrl = `${
    process.env[`REACT_APP_COGNITO_URL_${process.env.REACT_APP_ENV}`]
  }/logout?client_id=${
    process.env[`REACT_APP_COGNITO_CLIENT_ID_${process.env.REACT_APP_ENV}`]
  }&response_type=code&redirect_uri=${
    process.env[`REACT_APP_COGNITO_REDIRECT_URI_${process.env.REACT_APP_ENV}`]
  }`;

  removeToken('id_token');
  removeToken('refresh_token');
  fetchWithoutToken(fetchTokenUrl);
  window.location = fetchTokenUrl;
};

const reFreshCognitoTokens = refresh_token => {
  const fetchTokenUrl = `${
    process.env[`REACT_APP_COGNITO_URL_${process.env.REACT_APP_ENV}`]
  }/oauth2/token/?client_id=${
    process.env[`REACT_APP_COGNITO_CLIENT_ID_${process.env.REACT_APP_ENV}`]
  }&grant_type=refresh_token&refresh_token=${refresh_token}`;

  return fetchWithoutToken(`${fetchTokenUrl}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

const getOrders = init => {
  const condition = { supplierId: '' };
  if (getIsAllowSwitchSupplier()) {
    condition.supplierId = getCurrentSupplierId();
  }
  const fields = `*,orderLines/(id,saleId,shippingEndsAt,shippingStatusLabel,quantity,returnReason,unitCost,costCurrency,product(id,code,title,alternateTitle,price,cost,supplierId,/brand/name),productColour/colour,productSize/size,orderShipment(id,reference,consignment,carrier,shippingEndsAt,status,cost,supplierInputCost),productVariant(barcode),orderModification(id,orderId,variantId,quantity)),shippingRegion/(name,shippingCountryName)`;
  return fetch(
    `${url}${subUrls.ORDERS_LIST}?${qs.stringify(
      merge(init, DEFAULT_FILTERS, { fields }, condition)
    )}`,
    merge(options, {
      method: 'GET',
    })
  );
};

const getStatements = init => {
  const condition = { supplierId: '' };
  if (getIsAllowSwitchSupplier()) {
    condition.supplierId = getCurrentSupplierId();
  }
  return fetch(
    `${url}${subUrls.SUPPLIER_STATEMENT}?${qs.stringify(merge(init, condition))}`,
    merge(options, {
      method: 'GET',
    })
  ).then(res => {
    if (res.url) {
      return fetchWithoutToken(res.url);
    }
    return {
      errors: [res],
    };
  });
};

const getProducts = init => {
  const condition = { supplierId: '' };
  if (getIsAllowSwitchSupplier()) {
    condition.supplierId = getCurrentSupplierId();
  }
  const fields = `id,alternateTitle,title,soldAmount,soldQuantity,availableQuantity,inCheckingQuantity`;
  return fetch(
    `${url}${subUrls.PRODUCTS}?${qs.stringify(
      merge(init, DEFAULT_FILTERS, { fields }, condition)
    )}`,
    merge(options, {
      method: 'GET',
    })
  );
};

const updateProducts = variants =>
  fetch(
    `${url}${subUrls.PRODUCTS_UPDATE}`,
    merge(
      {
        body: JSON.stringify(variants),
      },
      options,
      { method: 'PUT' }
    )
  );

const getProductVariances = init => {
  const condition = { supplierId: '' };
  if (getIsAllowSwitchSupplier()) {
    condition.supplierId = getCurrentSupplierId();
  }
  const fields = `id,alternateTitle,title,code,cost,createdAt,isLive,productVariants(id,quantity,barcode,productSize(size),productColour(colour),soldAmount,soldQuantity,inCheckingQuantity)`;
  return fetch(
    `${url}${subUrls.PRODUCTS_VARIANCES}?${qs.stringify(
      merge(init, DEFAULT_FILTERS, { fields }, condition)
    )}`,
    merge(options, {
      method: 'GET',
    })
  );
};

const orderUpdate = init =>
  // return fetch(`${url}${ORDERS_UPDATE}`, merge(init, options)).then(handleResponse);
  fetch(
    `${url}${subUrls.ORDERS_LIST}`,
    merge({ body: JSON.stringify(init) }, options, { method: 'PUT' })
  );

const splitShipment = init =>
  fetch(
    `${url}${subUrls.ORDERS_SHIPMENT_SPLIT}`,
    merge({ body: JSON.stringify(init) }, DEFAULT_FILTERS, options, { method: 'POST' })
  );

const exportOrders = init => {
  const condition = { supplierId: '' };
  if (getIsAllowSwitchSupplier()) {
    condition.supplierId = getCurrentSupplierId();
  }
  const fields = `id,signatureRequired,deliveryInstructions,deliveryAddress(name,phonenumber,address1,address2,suburb,city,postcode),orderLines(quantity,unitCost,costCurrency,colour(colour),size(size),orderShipment(reference,status,carrier,consignment,id,cost,supplierInputCost),product(title,alternateTitle),productVariants(id,barcode))`;
  return fetch(
    `${url}${subUrls.ORDERS_LIST}?${qs.stringify(
      merge(init, DEFAULT_FILTERS, { fields }, condition)
    )}`,
    merge(options, {
      method: 'GET',
    })
  );
};
const removeTrackingNumber = (orderId, shipmentRef) =>
  fetch(
    `${url}orders/orders/${orderId}/shipments/${shipmentRef}`,
    merge(options, { method: 'DELETE' })
  );

const orderShipmentStats = () => {
  const condition = { supplierId: '' };
  if (getIsAllowSwitchSupplier()) {
    condition.supplierId = getCurrentSupplierId();
  }
  return fetch(
    `${url}${subUrls.ORDERS_SHIPMENT_STATS}?${qs.stringify(merge(DEFAULT_FILTERS, condition))}`,
    merge(options)
  );
};

const ordersRevenue = () => {
  const condition = { supplierId: '' };
  if (getIsAllowSwitchSupplier()) {
    condition.supplierId = getCurrentSupplierId();
  }
  return fetch(
    `${url}${subUrls.ORDERS_REVENUE}?${qs.stringify(merge(DEFAULT_FILTERS, condition))}`,
    merge(options, DEFAULT_FILTERS)
  );
};

const ordersByStatus = () => {
  const condition = { supplierId: '' };
  if (getIsAllowSwitchSupplier()) {
    condition.supplierId = getCurrentSupplierId();
  }
  return fetch(
    `${url}${subUrls.ORDERS_BY_STATUS}?${qs.stringify(merge(DEFAULT_FILTERS, condition))}`,
    merge(options, DEFAULT_FILTERS)
  );
};

const ordersList = () => {
  const condition = {};
  if (getIsAllowSwitchSupplier()) {
    condition.supplierId = getCurrentSupplierId();
  }
  return fetch(
    `${url}${subUrls.ORDERS_LIST}?${qs.stringify(
      merge(
        { page: 2 },
        DEFAULT_FILTERS,
        { fields: 'id,orderStatus,orderLines/totalPrice' },
        condition
      )
    )}`,
    merge(options)
  );
};

const getMarketplaceSuppliers = () =>
  fetch(
    `${url}${subUrls.MARKETPLACE_SUPPLIERS}`,
    merge(options, {
      method: 'GET',
    })
  );

/**
 * Get all carriers
 * @return {*}
 */
const getCarriers = () =>
  fetch(
    `${url}${subUrls.CARRIERS}`,
    merge(options, {
      method: 'GET',
    })
  );

module.exports = {
  getOrders,
  orderUpdate,
  orderShipmentStats,
  ordersRevenue,
  ordersByStatus,
  exportOrders,
  ordersList,
  getCognitoTokens,
  reFreshCognitoTokens,
  cognitoLogOut,
  removeTrackingNumber,
  getProducts,
  getProductVariances,
  getStatements,
  splitShipment,
  updateProducts,
  getMarketplaceSuppliers,
  getCarriers,
};



// WEBPACK FOOTER //
// ./src/api/index.js